export default __webpack_public_path__ + "static/media/Captain's Armguards of the Battlements.f8037085.jpg";